import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { styled } from '@uhg-abyss/web/tools/styled';
import React from 'react';

/**
 * GlobalStyles
 *
 * @TODO - Needs description.
 *
 * @param children
 * @returns {Element}
 * @constructor
 */
export function GlobalStyles({ children }) {
  const Styles = styled('div', {
    "*[class*='isDisabled-true']": {
      color: 'var(--abyss-colors-gray5) !important',
      cursor: 'not-allowed !important',
    },
    "*[class*='isDisabled-true'] .abyss-icon, *[class*='variant-isDisabled'] .abyss-icon": {
      color: 'var(--abyss-colors-gray5) !important',
      fill: 'var(--abyss-colors-gray5) !important',
    },
    "*[class*='widget-ire'] .abyss-card-root": {
      borderTop: '2px solid var(--abyss-colors-interactive1) !important',
    },
    'main#app-main': {
      minHeight: 'calc(100vh + 150px)',
    },
  });

  return (
    <ErrorHandler location="src/app/styles/GlobalStyles.jsx">
      <Styles>{children}</Styles>
    </ErrorHandler>
  );
}
